<template>
  <SignedIn>
    <MainLayout />
  </SignedIn>
  <SignedOut>
    <div class="h-full flex items-center justify-center">
      <SignUp
        v-if="route.path === '/signup'"
        signInUrl="/signin"
        forceRedirectUrl="/"
        fallbackRedirectUrl="/"
        waitlistUrl="/waitlist"
      />
      <Waitlist v-else-if="route.path === '/waitlist'" />
      <SignIn
        v-else
        :fallbackRedirectUrl="route.path"
        waitlistUrl="/waitlist"
      />
    </div>
  </SignedOut>
</template>
<script setup lang="ts">
import MainLayout from "./layouts/MainLayout.vue";

import {
  useClerk,
  useUser,
  SignedIn,
  SignedOut,
  SignUp,
  Waitlist,
  SignIn,
} from "@clerk/vue";
import { OpenAPI } from "./client";
import { watch } from "vue";

// import SignIn from "./pages/SignIn.vue";
// import SignUp from "./pages/SignUp.vue";
import { useRoute } from "vue-router";
import posthog from "posthog-js";
// import Waitlist from "./components/Waitlist.vue";

const route = useRoute();

const { isLoaded, isSignedIn, user } = useUser();
const clerk = useClerk();

OpenAPI.BASE = import.meta.env.VITE_APP_API_BASE_URL;

async function fetchToken() {
  let token;
  try {
    // console.log("Fetching token...");
    token = clerk.value.session?.getToken({
      template: "deetest-template",
    });
    // console.log(token);
  } catch (error) {
    console.error("Failed to get token:", error);
  }
  return token || "";
}

watch(
  isSignedIn,
  async (newIsSignedIn, oldIsSignedIn) => {
    if (newIsSignedIn) {
      OpenAPI.TOKEN = fetchToken;
    }
  },
  { immediate: true }
);

// const redirectUrl = window.location.href;

// posthog capture
function captureUser() {
  // console.log(user.value);

  if (user.value?.id) {
    posthog.identify(user.value.id, {
      name: user.value?.fullName,
      email: user.value?.primaryEmailAddress?.emailAddress,
    });
  }
}

captureUser();

watch(
  () => user.value,
  () => {
    captureUser();
  },
  { deep: true }
);
</script>
